import { IMortalityRecipient } from "@nkr/models/index";
import { Alert, Button, Modal } from "react-bootstrap";
import { TableWrapper } from '../styles';
import Row from './row'

interface IProps {
    show: boolean,
    items: IMortalityRecipient[],
    onClose: () => void
}

const MortalityRecipients = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} bsSize='lg' dialogClassName="action-center-mortality-modal" onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>TO-DO - At-Risk Mortality Recipients</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle="info">
                    For the patient(s) listed below, there are biologically matched donors available, but all have been declined by your center. 
                    Some of these donors may still be available for match offers. We encourage your team to consider reassessing potential donors in the event any may be suitable. 
                    Accepting one or more of these available donors may result in a match opportunity sooner and reduce your patient(s) mortality risk.
                </Alert>
                <TableWrapper className="table table-condensed table-striped table-bordered">
                    <thead>
                        <tr>
                            <th><strong>R#</strong></th>
                            <th><strong>Type</strong></th>
                            <th><strong>Recipient</strong></th>
                            <th><strong>ABO</strong></th>
                            <th><strong>Age</strong></th>
                            <th><strong>NKR cPRA</strong></th>
                            <th><strong>NKR Wait Time <br/> (months)</strong></th>
                            <th><strong>Forecasted Wait <br/> Time (months)</strong></th>
                            <th><strong>Time on Dialysis <br/> (months) </strong></th>
                            <th><strong>1-Year Mortality <br/> Risk</strong></th>
                            <th><strong>Donor Decline <br/> Ratio</strong></th>
                            <th><strong>Potential Donors</strong></th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.items?.map((item, index) => {
                            return (
                                <Row
                                    index={index + 1}
                                    data={item}
                                />
                            )
                        })}
                    </tbody>
                </TableWrapper>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default MortalityRecipients;